import { useRef } from 'react';

export const useFirst = <T>(value: T): T => useRef<T>(value).current;
